export class DeliveryMethod {
	id: number;
	delivery_method: string;
	description: string;
	user_created: string;
	user_modified: string;
	created_at: string;
	updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/delivery_method.ts